import { Accordion, AccordionContent, AccordionTitle, Checkbox, Dropdown, FormCheckbox, Icon, Input } from "semantic-ui-react";
import CustomModal from "src/components/configuracion/components/customModal";
import './CashFlowHolding.scss'
import { useState } from "react";
import { MergeCategoryAreas, UnmergeArea, UpdateMergedArea } from "src/graphql/cashflowHolding";
import { useDispatch } from "react-redux";
import { importAlertState } from "src/redux/actions/alert";
import { useEffect } from "react";

export const MergeAreasModal = ({
    modalIsOpen,
    incomeList,
    expenseList,
    holdingCashFlowId,
    setMergeAreasModalIsOpen,
    reexecuteHoldingFlow,
    reExecuteQueryHoldingFlowStructure,
    mergeAreasModalData,
    setMergeAreasModalData
}) => {
    const dispatch = useDispatch();

    // *********************** Variables *********************** //
    const [hasInitialized, setHasInitialized] = useState(false);
    const [mergedAreaName, setMergedAreaName] = useState('');
    const [incomeActiveIndices, setIncomeActiveIndices] = useState([]);
    const [expenseActiveIndices, setExpenseActiveIndices] = useState([]);
    const [selectedAreas, setSelectedAreas] = useState([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState();
    const [dropdownOptions, setDropdownOptions] = useState([]);
    const [targetCategory, setTargetCategory] = useState();
    const [cleanedIncomeList, setCleanedIncomeList] = useState([]);
    const [cleanedExpenseList, setCleanedExpenseList] = useState([]);

    // *********************** Graph *************************** //
    const { fetching, executeMutation: mergeCategoryAreasExecuteMutation } = MergeCategoryAreas();
    const { fetching: unmergeAreaFetching, executeMutation: unmergeAreaExecuteMutation } = UnmergeArea();
    const { fetching: UpdateMergedAreaFetching, executeMutation: updateMergedAreaExecuteMutation } = UpdateMergedArea();

    // *********************** Lógica *************************** //
    const handleClick = (index, type) => {
        if (type === 'income') {
            setIncomeActiveIndices(prev =>
                prev.includes(index)
                    ? prev.filter(i => i !== index)
                    : [...prev, index]
            );
        }
        if (type === 'expense') {
            setExpenseActiveIndices(prev =>
                prev.includes(index)
                    ? prev.filter(i => i !== index)
                    : [...prev, index]
            );
        }
    };

    useEffect(() => {
        if (!modalIsOpen || hasInitialized) return;

        let categoryIdSet = false;

        const activeIncomeIndices = incomeList.reduce((acc, income, index) => {
            const hasSelectedField = income.fields.some(field =>
                selectedAreas.includes(field.cashflowAreaId)
            );
            if (hasSelectedField) {
                acc.push(index);
                if (!categoryIdSet) {
                    setSelectedCategoryId(income.cashflowCategoryId);
                    categoryIdSet = true;
                }
            }
            return acc;
        }, []);

        const activeExpenseIndices = expenseList.reduce((acc, expense, index) => {
            const hasSelectedField = expense.fields.some(field =>
                selectedAreas.includes(field.cashflowAreaId)
            );
            if (hasSelectedField) {
                acc.push(index);
                if (!categoryIdSet) {
                    setSelectedCategoryId(expense.cashflowCategoryId);
                    categoryIdSet = true;
                }
            }
            return acc;
        }, []);

        setIncomeActiveIndices(activeIncomeIndices);
        setExpenseActiveIndices(activeExpenseIndices);
        getDropdownOptions();
        cleanAreaOptions();
        setHasInitialized(true);
    }, [modalIsOpen, incomeList, expenseList, selectedAreas]);

    const onCheckboxChange = (isChecked, field, category) => {
        if (!selectedCategoryId) {
            setSelectedCategoryId(category.cashflowCategoryId);
        }

        if (isChecked) {
            const newSelectedAreas = [...selectedAreas, field?.cashflowAreaId];
            setSelectedAreas(newSelectedAreas);
        } else {
            const newSelectedAreas = selectedAreas.filter(area => area !== field?.cashflowAreaId);
            setSelectedAreas(newSelectedAreas);
        }
    }

    const mergeAreas = async () => {
        dispatch(
            importAlertState({
                content: "Creando nueva área...",
                state: "loading",
                duration: 10
            })
        )

        const { data, error } = await mergeCategoryAreasExecuteMutation(
            {
                mergedAreaName: mergedAreaName,
                targetCategoryId: targetCategory,
                areaIdsToMerge: selectedAreas,
                holdingFlowId: holdingCashFlowId,
            }
        );

        if (data?.mergeCategoryAreas) {
            dispatch(
                importAlertState({
                    content: data?.mergeCategoryAreas?.message,
                    state: data?.mergeCategoryAreas?.status,
                    duration: 5
                })
            );
        }

        if (error) {
            dispatch(
                importAlertState({
                    content: "Error al combinar área.",
                    state: "success",
                    duration: 5
                })
            );
        }

        if (data?.mergeCategoryAreas?.status == 'success') {
            onClose();
        }
    }

    const unmergeAreas = async () => {
        dispatch(
            importAlertState({
                content: "Separando área...",
                state: "loading",
                duration: 10
            })
        )

        const { data, error } = await unmergeAreaExecuteMutation(
            {
                holdingFlowId: holdingCashFlowId,
                mergedAreaId: mergeAreasModalData?.cashflowAreaId,
            }
        );

        if (data?.unmergeArea) {
            dispatch(
                importAlertState({
                    content: data?.unmergeArea?.message,
                    state: data?.unmergeArea?.status,
                    duration: 5
                })
            );
        }

        if (error) {
            dispatch(
                importAlertState({
                    content: "Error al separar área.",
                    state: "success",
                    duration: 5
                })
            );
        }

        if (data?.unmergeArea?.status == 'success') {
            onClose();
        }
    }

    const updateMergedAreas = async () => {
        dispatch(
            importAlertState({
                content: "Editando área...",
                state: "loading",
                duration: 10
            })
        )

        const { data, error } = await updateMergedAreaExecuteMutation(
            {
                holdingFlowId: holdingCashFlowId,
                mergedAreaId: mergeAreasModalData?.cashflowAreaId,
                targetCategoryId: targetCategory,
                newName: mergedAreaName,
                newAreaIds: selectedAreas
            }
        );

        if (data?.updateMergedArea) {
            dispatch(
                importAlertState({
                    content: data?.updateMergedArea?.message,
                    state: data?.updateMergedArea?.status,
                    duration: 5
                })
            );
        }

        if (error) {
            dispatch(
                importAlertState({
                    content: "Error al editar área.",
                    state: "success",
                    duration: 5
                })
            );
        }

        if (data?.updateMergedArea?.status == 'success') {
            onClose();
        }
    }

    const onClose = () => {
        setMergeAreasModalIsOpen(undefined);
        setIncomeActiveIndices([]);
        setSelectedAreas([]);
        setSelectedCategoryId(undefined);
        setMergeAreasModalIsOpen(false);
        setMergedAreaName('');
        reexecuteHoldingFlow({ requestPolicy: 'cache-and-network' });
        reExecuteQueryHoldingFlowStructure({ requestPolicy: 'cache-and-network' });
        setTargetCategory('');
        setHasInitialized(false);
        if (mergeAreasModalData) {
            setMergeAreasModalData(undefined);
        }
    }

    useEffect(() => {
        if (!mergeAreasModalData) return;
        setMergedAreaName(mergeAreasModalData?.label);
        setSelectedAreas(mergeAreasModalData?.mergedFrom);
        setTargetCategory(mergeAreasModalData?.cashflowCategoryId);
    }, [mergeAreasModalData])

    const getDropdownOptions = () => {
        let options = [];
        incomeList?.map((income) => {
            const option = {
                key: income?.cashflowCategoryId,
                text: income?.label,
                value: income?.cashflowCategoryId
            };

            options.push(option);
        });

        expenseList?.map((expense) => {
            const option = {
                key: expense?.cashflowCategoryId,
                text: expense?.label,
                value: expense?.cashflowCategoryId
            };

            options.push(option);
        });

        setDropdownOptions(options);
    }

    const cleanAreaOptions = () => {
        const cleanedIncomes = incomeList.map((income) => ({
            ...income,
            fields: income?.fields?.filter(field => {
                if (mergeAreasModalData?.mergedFrom.includes(field.cashflowAreaId)) {
                    return field;
                } else {
                    const hasMergedFromData = Array.isArray(field.mergedFrom)
                        ? field.mergedFrom.length > 0
                        : !!field.mergedFrom;
                    return !hasMergedFromData && !field.isMerged;
                }
            }) ?? []
        }));

        setCleanedIncomeList(cleanedIncomes);

        const cleanedExpenses = expenseList.map((expense) => ({
            ...expense,
            fields: expense?.fields?.filter(field => {
                if (mergeAreasModalData?.mergedFrom.includes(field.cashflowAreaId)) {
                    return field;
                } else {
                    const hasMergedFromData = Array.isArray(field.mergedFrom)
                        ? field.mergedFrom.length > 0
                        : !!field.mergedFrom;
                    return !hasMergedFromData && !field.isMerged;
                }
            }) ?? []
        }));

        setCleanedExpenseList(cleanedExpenses);
    }

    return (
        <CustomModal
            open={modalIsOpen}
            onClose={onClose}
            title={"Combinar Áreas - Flujo de caja"}
            classNameTitle={"tw-text-center"}
            size="large"
            content={
                <div className="tw-flex tw-flex-col tw-gap-[20px]">
                    <span className="tw-font-light tw-text-sm">
                        Selecciona dos o más áreas, ingresa un nombre y haz clic en "Combinar". El monto total se actualizará en el flujo de caja.
                    </span>

                    <section>
                        <div className="tw-flex tw-justify-between cash-flow-filters">
                            <div className="tw-flex tw-gap-3 tw-w-full">
                                <Input
                                    placeholder="Nombre de la nueva área combinada"
                                    className="tw-w-[300px] !tw-h-full !tw-text-base"
                                    onChange={(event) => setMergedAreaName(event.target.value)}
                                    value={mergedAreaName}
                                />

                                <div className="tw-w-[202px]">
                                    <Dropdown
                                        placeholder='Seleccionar Categoría'
                                        fluid
                                        selection
                                        className="tw-h-full"
                                        options={dropdownOptions}
                                        value={targetCategory}
                                        onChange={(event, data) => setTargetCategory(data.value)}
                                    />
                                </div>

                                <button
                                    className="tw-h-full tw-w-[101px] tw-bg-pepper-500 tw-text-white tw-font-medium tw-text-sm tw-border-none tw-rounded disabled:tw-bg-pepper-300 disabled:tw-text-white/70"
                                    onClick={
                                        mergeAreasModalData
                                            ? updateMergedAreas
                                            : mergeAreas
                                    }
                                    disabled={selectedAreas.length < 2 || !mergedAreaName || !targetCategory || fetching || unmergeAreaFetching}
                                >
                                    {
                                        mergeAreasModalData
                                            ? 'Editar'
                                            : 'Combinar'
                                    }
                                </button>
                                {
                                    mergeAreasModalData?.cashflowAreaId &&
                                    <button
                                        className="tw-h-full tw-w-[101px] tw-bg-pepper-500 tw-text-white tw-font-medium tw-text-sm tw-border-none tw-rounded disabled:tw-bg-pepper-300 disabled:tw-text-white/70"
                                        onClick={unmergeAreas}
                                        disabled={fetching || unmergeAreaFetching}
                                    >
                                        Separar
                                    </button>
                                }
                            </div>

                            {/* <div className="tw-w-[195px] tw-h-full tw-flex tw-items-center tw-justify-between tw-gap-[14px]">
                                <Checkbox
                                    toggle
                                    className="custom-checkbox"
                                />

                                <span className="tw-font-light tw-text-sm">
                                    Mostrar todas las áreas
                                </span>
                            </div> */}
                        </div>

                    </section>


                    <section className="tw-flex tw-gap-5 tw-justify-between">
                        <div className="tw-flex-1 tw-rounded-[5px] tw-min-h-[419px] tw-border-solid tw-border tw-border-gray-200">
                            <div className="tw-h-[37px] tw-w-full tw-py-[8px] tw-px-[15px] tw-bg-gray-100 tw-rounded-t-[5px]">
                                <span className="tw-font-medium tw-text-base">INGRESOS</span>
                            </div>
                            <div className="tw-h-full tw-w-full tw-py-[5px] tw-px-[10px]">
                                <Accordion exclusive={false}>
                                    {
                                        cleanedIncomeList?.map((income, index) => {
                                            return (
                                                income?.fields.length > 0 &&
                                                <>
                                                    <AccordionTitle
                                                        key={`title-${index}`}
                                                        active={incomeActiveIndices.includes(index)}
                                                        index={index}
                                                        onClick={() => handleClick(index, 'income')}
                                                    >
                                                        <Icon name={incomeActiveIndices.includes(index) ? 'angle down' : 'angle right'} />
                                                        <span className="tw-font-normal tw-text-sm">
                                                            {income?.label}
                                                        </span>
                                                    </AccordionTitle>
                                                    <AccordionContent key={`content-${index}`} active={incomeActiveIndices.includes(index)}>
                                                        {
                                                            income?.fields.map((field) => {
                                                                return (
                                                                    <div className="tw-py-[5px] tw-px-[15px] tw-h-[28px] tw-flex tw-gap-[22px] tw-items-center">
                                                                        <FormCheckbox
                                                                            onChange={(e, data) => onCheckboxChange(data.checked, field, income)}
                                                                            checked={selectedAreas.includes(field?.cashflowAreaId)}
                                                                        />
                                                                        <span className="tw-font-light tw-text-sm">
                                                                            {field?.label}
                                                                        </span>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </AccordionContent>
                                                </>
                                            )
                                        })
                                    }
                                </Accordion>
                            </div>
                        </div>
                        <div className="tw-flex-1 tw-rounded-[5px] tw-min-h-[419px] tw-border-solid tw-border tw-border-gray-200">
                            <div className="tw-h-[37px] tw-w-full tw-py-[8px] tw-px-[15px] tw-bg-gray-100 tw-rounded-t-[5px]">
                                <span className="tw-font-medium tw-text-base">EGRESOS</span>
                            </div>
                            <div className="tw-h-full tw-w-full tw-py-[5px] tw-px-[10px]">
                                <Accordion exclusive={false}>
                                    {
                                        cleanedExpenseList?.map((expense, index) => {
                                            return (
                                                <>
                                                    <AccordionTitle
                                                        key={`title-${index}`}
                                                        active={expenseActiveIndices.includes(index)}
                                                        index={index}
                                                        onClick={() => handleClick(index, 'expense')}
                                                    >
                                                        <Icon name={expenseActiveIndices.includes(index) ? 'angle down' : 'angle right'} />
                                                        <span className="tw-font-normal tw-text-sm">
                                                            {expense?.label}
                                                        </span>
                                                    </AccordionTitle>
                                                    <AccordionContent key={`content-${index}`} active={expenseActiveIndices.includes(index)}>
                                                        {
                                                            expense?.fields.map((field) => {
                                                                return (
                                                                    <div className="tw-py-[5px] tw-px-[15px] tw-h-[28px] tw-flex tw-gap-[22px] tw-items-center">
                                                                        <FormCheckbox
                                                                            onChange={(e, data) => onCheckboxChange(data.checked, field, expense)}
                                                                            checked={selectedAreas.includes(field?.cashflowAreaId)}
                                                                        />
                                                                        <span className="tw-font-light tw-text-sm">
                                                                            {field?.label}
                                                                        </span>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </AccordionContent>
                                                </>
                                            )
                                        })
                                    }
                                </Accordion>
                            </div>
                        </div>
                    </section>
                </div>
            }
        />
    );
};
